import React from 'react'
import Navbar from '../components/Navbar'
import VidaliComp from '../components/Vidali_comp'
import Footer from '../components/Footer'

function VidaliUrunler() {
  return (
    <div>
        <Navbar />
        <VidaliComp />
        <Footer />
    </div>
  )
}

export default VidaliUrunler
